import React from 'react';
import './DynamicListCell.scss'
import moment from 'moment'
import i18next from "i18next";
import Loading from "../../Custom UI/Loading/Loading";
import ErrorIcon from '@material-ui/icons/Error';
import {CheckCircle} from "@material-ui/icons";
import LabeledSwitch from "../../Custom UI/LabeledInputs/LabeledSwitch/LabeledSwitch";
import LabeledDropDown from "../../Custom UI/LabeledInputs/LabeledDropDown/LabeledDropDown";
import {momentFromDate} from "../../Helpers/DateHelpers";
import LabeledDatePicker from "../../Custom UI/LabeledInputs/LabeledDatePicker/LabeledDatePicker";
import LabeledDelayedInput from "../../Custom UI/LabeledInputs/LabeledDelayedInput/LabeledDelayedInput";
import {setHours, setMinutes} from "date-fns";
import {BiDotsVerticalRounded} from "react-icons/bi";

const primitiveText = (value) => {
  if(typeof value === 'string' || typeof value === 'number'){
    const text = value.toString().trim();
    return text.length > 0 ? text : null;
  }
  return null;
};

const configuredValue = (value, ...args) =>
  typeof value === 'function' ? value(...args) : value;

export default class DynamicListCell extends React.Component {
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      reloadingCell:{}
    };
    this.reload = this.reload.bind(this);
    this.flexForWidth = this.flexForWidth.bind(this);
  }
  
  // Methods
  
  reload(aObject, aRow){
    const {reload, reloadDelay = 60000} = this.props;
    const {reloadingCell} = this.state;
    
    if(reload && !reloadingCell[aRow]){
      reloadingCell[aRow] = true;
      this.setState({reloadingCell:reloadingCell});
      setTimeout(() => {
        reloadingCell[aRow] = false;
        this.setState({reloadingCell:reloadingCell});
        reload(aObject, aRow);
      }, reloadDelay);
    }
    return true;
  }
  
  flexForWidth(aColumnWidth){
    return '0 0 ' + aColumnWidth.toString() + 'px';
  }

  rowLabel(){
    const {row, object, section, rowLabel} = this.props;
    const accessibleRow = this.props.accessibleRow === undefined ?
      row : this.props.accessibleRow;
    const configuredLabel = primitiveText(
      configuredValue(rowLabel, object, row, section)
    );

    if(configuredLabel){
      return configuredLabel;
    }
    if(object){
      const directLabel = [
        object.display,
        object.name,
        object.title,
        object.label,
        object.report_name,
        object.survey_name,
        object.email
      ].map(primitiveText).find(Boolean);

      if(directLabel){
        return directLabel;
      }
      const personName = [object.first_name, object.last_name]
        .map(primitiveText)
        .filter(Boolean)
        .join(' ');
      if(personName){
        return personName;
      }
      const nestedPersonName = object.user ?
        [object.user.first_name, object.user.last_name]
          .map(primitiveText)
          .filter(Boolean)
          .join(' ')
        :
        '';
      if(nestedPersonName){
        return nestedPersonName;
      }
      const identifier = primitiveText(object.id);
      if(identifier){
        return '#' + identifier;
      }
    }
    return i18next.t('DYNAMIC_LIST_ROW_FALLBACK', {
      number:accessibleRow + 1
    });
  }

  accessibleLabel(configuredLabel, translationKey, extra = {}){
    const {row, object, section} = this.props;
    const accessibleRow = this.props.accessibleRow === undefined ?
      row : this.props.accessibleRow;
    const resolvedRowLabel = this.rowLabel();
    return primitiveText(
      configuredValue(
        configuredLabel,
        object,
        row,
        section,
        resolvedRowLabel
      )
    ) || i18next.t(translationKey, {
      ...extra,
      record:resolvedRowLabel,
      number:accessibleRow + 1
    });
  }
  
  // Render
  
  render() {
    const {row, width, object, section, isLoading, selectCell, columnsArray, isSelectedRow, selectedColumn,
      clampFirstColumn = true, menuButtonClicked, valueForProperties, showMenu = true, showBorder = false,
      borderWidth = 0.5, semanticMode = false, rowActionAriaLabel, rowActionText,
      rowMenuAriaLabel} = this.props;
    const resolvedRowLabel = this.rowLabel();
    const rowActionLabel = this.accessibleLabel(
      rowActionAriaLabel,
      'DYNAMIC_LIST_SELECT_ROW'
    );
    const menuActionLabel = this.accessibleLabel(
      rowMenuAriaLabel,
      'DYNAMIC_LIST_ROW_ACTIONS'
    );
    let rowActionColumnIndex = columnsArray.findIndex((column) =>
      !column.select && !column.handleSave
    );
    if(rowActionColumnIndex < 0){
      rowActionColumnIndex = 0;
    }
    // TODO: Sarah, check class names.
    return (
      <div className={'dynamic-list-cell ' + (isSelectedRow ? 'dynamic-list-cell-selected-row' : '')}
           role={semanticMode ? 'row' : undefined}
           aria-selected={semanticMode && selectCell ? isSelectedRow : undefined}
           style={{width:width + 'px'}}
           onClick={!semanticMode && selectCell ? () => selectCell() : null}>
        {columnsArray.map((column, index) => (
          <div className={'dynamic-list-cell-text ' + (clampFirstColumn ? 'dynamic-list-cell-clamped ' : '') + (selectedColumn === index ? 'dynamic-list-cell-selected ' : '') + (showBorder ? 'dynamic-list-cell-border ': '')}
               id={'dynamic-list-cell-' + row + '-' + index}
               key={'dynamic-cell-column-key-' + (column.propertiesArray && column.propertiesArray.length > 0 ? valueForProperties(column.propertiesArray) : '') + '-' + index}
               role={semanticMode ? 'cell' : undefined}
               style={{width:column.width, flex:this.flexForWidth(column.width), borderLeftWidth:index === 0 ? borderWidth : 0, borderRightWidth:clampFirstColumn && index === 0 ? 2 * borderWidth : borderWidth, borderBottomWidth:borderWidth}}
               onClick={!semanticMode && column.select ? () => column.select(object, row) : null}>
            {column.handleSave && (!column.disabled || !column.disabled(object, row)) ?
              column.type === 'switch' ?
                <LabeledSwitch checked={valueForProperties(column.propertiesArray) === 'true' || valueForProperties(column.propertiesArray) === true}
                               onChange={(aChecked) => column.handleSave(aChecked, object, row)}
                               defaultChecked={false}
                />
                :
                column.optionsArray && column.optionsArray(object, row) ?
                  <LabeledDropDown className="dynamic-list-cell-labeled-dropdown"
                                   value={column.optionsArray(object, row).filter(function(option){
                                     return option.value === valueForProperties(column.propertiesArray);
                                   })}
                                   options={column.optionsArray(object, row)}
                                   handleSave={(aOption) => column.handleSave(aOption.value, object, row)}
                                   isClearable={false}
                                   placeholder={column.placeholder}
                  />
                  :
                  column.dateFormat && column.dateFormat.length > 0 ?
                    <LabeledDatePicker className="dynamic-list-cell-labeled-datepicker"
                                       label={i18next.t('START_DATE_PROPER_CAPITALIZED')}
                                       value={valueForProperties(column.propertiesArray) ? valueForProperties(column.propertiesArray) : false}
                                       maxDate={column.maxDate ? moment(column.maxDate).toDate() : null}
                                       maxTime={column.maxTime ? moment(column.maxTime).toDate() : setHours(setMinutes(new Date(), 59), 23)}
                                       minDate={column.minDate ? moment(column.minDate).toDate() : null}
                                       minTime={column.minTime ? moment(column.minTime).toDate() : setHours(setMinutes(new Date(), 0), 0)}
                                       dateFormat={column.dateFormat}
                                       handleSave={(aDate) => column.handleSave(aDate, object, row)}
                                       isClearable={true}
                                       timeCaption={i18next.t('TIME_PROPER_CAPITALIZED')}
                                       showTimeSelect={column.dateFormat.includes('HH')}
                                       placeholderText={i18next.t('SELECT_DATE')}
                                       popperPlacement={'bottom-start'}
                                       showPopperArrow={true}
                                       showYearDropdown={true}
                                       showMonthDropdown={true}
                    />
                    :
                    <LabeledDelayedInput value={valueForProperties(column.propertiesArray)}
                                         autoFocus="autoFocus"
                                         minLength={0}
                                         handleSave={(aEvent) => {
                                           aEvent.preventDefault();
                                           aEvent.stopPropagation();
                                           column.handleSave(aEvent, object, row);
                                         }}
                                         placeholder={column.placeholder}
                    />
              :
              column.dateFormat && column.dateFormat.length > 0 ?
                momentFromDate(valueForProperties(column.propertiesArray), column.dateFormat)
                :
                column.templateCell ?
                  <div className="dynamic-list-cell-template">
                    {column.templateCell(object, row, section)}
                  </div>
                  :
                  column.valueFormatter ?
                    column.valueFormatter(valueForProperties(column.propertiesArray), object, row, section)
                    :
                    valueForProperties(column.propertiesArray) === true ?
                      <CheckCircle style={{color:'green', height:'15px', marginTop:'4px'}}/>
                      :
                      <div className="dynamic-list-cell-properties-array">
                        {valueForProperties(column.propertiesArray) === false ?
                          <ErrorIcon style={{color:'#E02020', height:'15px', marginTop:'4px'}}/>
                          :
                          valueForProperties(column.propertiesArray)
                        }
                      </div>
            }

            {semanticMode && column.select ?
              <button className="dynamic-list-cell-action-button"
                      type="button"
                      aria-label={this.accessibleLabel(
                        column.actionAriaLabel,
                        'DYNAMIC_LIST_ACTIVATE_CELL',
                        {column:i18next.t(column.columnNameKey || 'ACTION')}
                      )}
                      onClick={(aEvent) => {
                        aEvent.preventDefault();
                        aEvent.stopPropagation();
                        column.select(object, row);
                      }}>
                {primitiveText(configuredValue(
                  column.actionText,
                  object,
                  row,
                  section,
                  resolvedRowLabel
                )) || i18next.t('ACTION')}
              </button>
              :
              null
            }

            {semanticMode && selectCell && index === rowActionColumnIndex ?
              <button className="dynamic-list-row-select-button"
                      type="button"
                      aria-label={rowActionLabel}
                      onClick={(aEvent) => {
                        aEvent.preventDefault();
                        aEvent.stopPropagation();
                        selectCell();
                      }}>
                {primitiveText(configuredValue(
                  rowActionText,
                  object,
                  row,
                  section,
                  resolvedRowLabel
                )) || i18next.t('SELECT')}
              </button>
              :
              null
            }
          </div>
        ))}
        
        {menuButtonClicked || !showMenu ?
          <div className={'dynamic-list-cell-loading-container ' + (showBorder ? 'dynamic-list-cell-border ': '')}
               role={semanticMode ? 'cell' : undefined}
               style={{borderBottomWidth:borderWidth, borderRightWidth:borderWidth}}>
            {showMenu ?
              (isLoading && isLoading(object, row) && this.reload(object, row) ?
                  <Loading size={'tiny'}
                           showLabel={false}
                  />
                  :
                  <button className="dynamic-list-row-menu-button"
                          type="button"
                          aria-label={menuActionLabel}
                          aria-haspopup="menu"
                          onClick={(aEvent) => {
                            aEvent.preventDefault();
                            aEvent.stopPropagation();
                            menuButtonClicked(aEvent);
                          }}>
                    <BiDotsVerticalRounded aria-hidden="true"
                                           focusable="false"
                                           style={{fontSize:'21px', height:'20px', width:(20 + borderWidth).toString() + 'px'}}
                    />
                  </button>
              )
              :
              null
            }
          </div>
          :
          null
        }
      </div>
    )
  }
}
